import { createContext, useState, ReactNode } from 'react'
import Publisher from '../types/Publisher'
import Partner from '../types/Partner'

export type SalesData = {
  roleId?: number
  publisherId?: number
  publishers: Publisher[]
  partner?: Partner
}

type ContextType = {
  data: SalesData
  setData: (data: SalesData) => void
}

type SalesProviderProps = {
  children: ReactNode
  values?: SalesData
}

const DEFAULT_VALUES = {
  publishers: []
}

export const SalesContext = createContext(undefined as ContextType | undefined)

const SalesProvider = ({
  children,
  values = DEFAULT_VALUES
}: SalesProviderProps) => {
  const [data, setData] = useState<SalesData>(values)

  return (
    <SalesContext.Provider value={{ data, setData }}>
      {children}
    </SalesContext.Provider>
  )
}

export default SalesProvider
